<script lang="ts">
	export let fill = "#bcbfc3";
	export let active = false;
	export let hover = false;

</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.434 20.029">
	<g>
		<g>
			<path
				fill={fill}
				class:active
				class:hover
				d="M-96.169 311.022a.7.7 0 0 1-.706-.706v-18.59a.7.7 0 0 1 .706-.706.705.705 0 0 1 .706.706v18.591a.705.705 0 0 1-.706.705z"
				transform="translate(96.875 -290.993)" />
		</g>
		<g>
			<g transform="translate(.169)">
				<circle
					fill={fill}
					class:hover
					class:active
					cx="6.632"
					cy="6.632"
					r="6.632" />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		overflow: visible;
	}

	path,
	circle {
		transition: all 0.5s;

		&.hover {
			fill: var(--default-hover-btn-1);
		}

		&.active {
			fill: var(--signature-blue) !important;
		}
	}

</style>
